import React, { PropsWithChildren } from "react";
import { useReadonlyContext } from "utilities/contexts/readonly/use-readonly-context";

interface ShowOnlyIfReadonlyProps {}

export const ShowOnlyIfReadonly: React.FC<
    PropsWithChildren<ShowOnlyIfReadonlyProps>
> = ({ children }): JSX.Element => {
    const { isReadonly } = useReadonlyContext();

    if (isReadonly) {
        return <>{children}</>;
    }

    return <></>;
};
